import { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { toast } from 'sonner';

interface ChatTriggerTestInputFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function ChatTriggerTestInputField({ value, onChange }: ChatTriggerTestInputFieldProps) {
  const [localValue, setLocalValue] = useState(value || '');

  const handleChange = (newValue: string) => {
    setLocalValue(newValue);
    onChange(newValue);
  };

  const generateSampleInput = () => {
    const sampleInput = JSON.stringify({
      message: 'Hello, this is a test message'
    }, null, 2);
    
    handleChange(sampleInput);
    toast.success('Sample test input generated', {
      description: 'You can modify this JSON to match your testing needs'
    });
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor="testInput" className="text-sm font-medium">
          Test Input Data
        </Label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={generateSampleInput}
          className="h-7 text-xs"
        >
          <Sparkles className="h-3 w-3 mr-1" />
          Generate Sample
        </Button>
      </div>
      <Textarea
        id="testInput"
        value={localValue}
        onChange={(e) => handleChange(e.target.value)}
        placeholder='{"message": "Hello", "sessionId": "test-123", "userId": "user-1"}'
        className="font-mono text-xs min-h-[120px]"
      />
      <p className="text-xs text-muted-foreground">
        Test input data to use when testing this workflow in the editor. This simulates incoming chat messages.
      </p>
    </div>
  );
}
